var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ru:admin-back"},[_c('Buttons',{attrs:{"layout":"start"}},[_c('RuButton',{attrs:{"level":"secondary","size":"small","href":_vm.to}},[_c('Icon',{attrs:{"id":"arrow-left"}}),_vm._v(" "),_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }